import type { SVGProps } from "react";
import * as React from "react";

const SvgBattery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 13a1 1 0 1 0 2 0zm2-2a1 1 0 1 0-2 0zM3 7h14V5H3zm14 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v8h2V8zm0 8a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H3v2h14zM3 17a1 1 0 0 1-1-1H0a3 3 0 0 0 3 3zm-1-1V8H0v8zm0-8a1 1 0 0 1 1-1V5a3 3 0 0 0-3 3zm22 5v-2h-2v2z"
    />
  </svg>
);
export default SvgBattery;
